
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.17 13.12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M18.92 4.66l-2.31-.53V.33c0-.18-.15-.33-.33-.33H.33C.15 0 0 .15 0 .33V8.9c0 .18.15.33.33.33h1.39v.04c-.03.09-.01.17.03.25.05.07.12.13.21.15l.17.04L17 13.13h.05c.15 0 .28-.1.32-.25l1.48-6.44.32-1.38c.02-.09 0-.17-.04-.25a.36.36 0 00-.21-.15zm-2.31 2.42V7.07zm-6.09 2.57c.46 0 .91-.13 1.31-.38.02-.02.05-.03.07-.05h4.22l-.16.7h-.15c-.66 0-1.26.35-1.58.91-.05.08-.09.17-.12.26L6.02 9.23h3.11c.06.04.13.08.19.12.05.03.1.05.15.08.15.07.32.13.49.17.19.04.37.06.56.06zm-.38-.43h.77c-.25.05-.51.05-.77 0zM.66 8.56V.66h15.29v7.91H.66zm16.14 3.83L3.03 9.22H5.1c0 .06.05.12.12.13l8.96 2.06h.03c.07 0 .13-.04.15-.11.18-.65.76-1.08 1.41-1.09.09 0 .19 0 .28.02.08.01.16-.04.18-.12l.22-.95s.05-.03.06-.05c.06-.06.09-.14.09-.23v-.41L16.94 7a.15.15 0 00-.11-.18.917.917 0 01-.23-.09V4.79l1.84.42-1.65 7.17z"}}),_c('path',{attrs:{"d":"M14.69 2.74c-.79-.04-1.42-.69-1.46-1.52 0-.09-.08-.15-.16-.15H3.54c-.09 0-.16.07-.16.15-.04.82-.67 1.48-1.46 1.52-.09 0-.15.08-.15.16v3.42c0 .09.07.16.15.16.79.04 1.42.69 1.46 1.52 0 .09.08.15.16.15h9.52c.09 0 .16-.07.16-.15.04-.82.67-1.48 1.46-1.52.09 0 .15-.08.15-.16V2.9c0-.09-.07-.16-.15-.16zm-.17 3.43c-.84.11-1.49.79-1.6 1.66H3.69c-.11-.86-.76-1.54-1.6-1.66V3.05c.84-.11 1.49-.79 1.6-1.65h9.23c.11.86.76 1.54 1.6 1.65v3.12z"}}),_c('path',{attrs:{"d":"M8.39 1.97c-1.42 0-2.57 1.19-2.57 2.64s1.15 2.64 2.57 2.64 2.57-1.19 2.57-2.64-1.15-2.64-2.57-2.64zm0 4.88c-1.19 0-2.16-1-2.16-2.23s.97-2.23 2.16-2.23 2.16 1 2.16 2.23-.97 2.23-2.16 2.23z"}})])])
          )
        }
      }
    